<!-- Index-2 component -->
<script>
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import {scrollTo} from "svelte-scrollto";

  import Navbar from "../Components/Navbar.svelte";
  import Services from "../Components/Services.svelte";
  import Experience from "../Components/Experience.svelte";
  import Pricing from "../Components/Pricing.svelte";
  import Team from "../Components/Team.svelte";
  import Testimonial from "../Components/Testimonial.svelte";
  import Blog from "../Components/Blog.svelte";
  import Contact from "../Components/Contact.svelte";
  import Footer from "../Components/Footer.svelte";
  import Switcher from "../Components/Switcher.svelte";

  import data from "../Data/data";

  let open = false;
  let comments;

  const toggle = () => {
    open = !open;
  };
  const contactWithComments = event => {
    comments = event.detail.text
    scrollTo({element: '#contact'})
  }
</script>

<!-- STRAT NAVBAR -->

<Navbar />

<!--START HOME-->

<section
  class="section bg-home home-half active common-section"
  id="home"
  data-image-src="images/bg-home.jpg"
>
  <div class="bg-overlay" />
  <div class="display-table">
    <div class="display-table-cell">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-white text-center">
            <h1 class="home-title">We help Ohio residents improve their way of living</h1>
            <p class="pt-3 home-desc">
               Looking for a professional contractor?
            </p>
            <Modal isOpen={open} {toggle} size="lg">
              <ModalHeader {toggle} />
              <ModalBody>
                <video
                  id="VisaChipCardVideo"
                  class="video-box"
                  src="https://www.w3schools.com/html/mov_bbb.mp4"
                  controls
                >
                  <track default kind="captions" type="video/mp4" />
                </video>
              </ModalBody>
            </Modal>
            <!-- Modal -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wave-effect wave-anim">
    <div class="waves-shape shape-one">
      <div
        class="wave wave-one"
        style="background-image: url('images/wave-shape/wave1.png')"
      />
    </div>
    <div class="waves-shape shape-two">
      <div
        class="wave wave-two"
        style="background-image: url('images/wave-shape/wave2.png')"
      />
    </div>
    <div class="waves-shape shape-three">
      <div
        class="wave wave-three"
        style="background-image: url('images/wave-shape/wave3.png')"
      />
    </div>
  </div>
</section>
<!--END HOME-->
<Services serviceData={data.SERVICE_DATA} on:comments={contactWithComments}/>
<Experience featureData={data.EXPERIENCE_DATA} on:comments={contactWithComments}/>
<!--
<Pricing pricingData={data.PRICING_DATA} on:comments={contactWithComments}/>
-->
<Team teamData={data.TEAM_DATA} on:comments={contactWithComments}/>
<Testimonial testimonialData={data.TESATIMONIAL_DATA} on:comments={contactWithComments}/>
<Blog blogData={data.BLOG_DATA} />
<Contact {comments}/>
<Footer />
